import { render, staticRenderFns } from "./my-contract.vue?vue&type=template&id=2523efde&scoped=true"
import script from "./my-contract.vue?vue&type=script&lang=js"
export * from "./my-contract.vue?vue&type=script&lang=js"
import style0 from "./my-contract.vue?vue&type=style&index=0&id=2523efde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523efde",
  null
  
)

export default component.exports